import { render } from "./CardLegend.vue?vue&type=template&id=74a112ed&scoped=true&ts=true"
import script from "./CardLegend.vue?vue&type=script&lang=ts"
export * from "./CardLegend.vue?vue&type=script&lang=ts"

import "./CardLegend.vue?vue&type=style&index=0&id=74a112ed&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a112ed"],['__file',"src/components/CardLegend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74a112ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74a112ed', __exports__)) {
    api.reload('74a112ed', __exports__)
  }
  
  module.hot.accept("./CardLegend.vue?vue&type=template&id=74a112ed&scoped=true&ts=true", () => {
    api.rerender('74a112ed', render)
  })

}


export default __exports__